import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default function StackedSection(){
    function init() {
        try {
            let pointNav = document.querySelector('.card__point').clientHeight
            let offsetTop = pointNav+30; //distance given when the first trigger section starts + 30px white gradient at the bottom
            const sections = gsap.utils.toArray(".stacked_card__section"); //variables for sections
            const cardItems = document.querySelectorAll(".stacked_card__item");
            const spacer = 30; //number to adjust the distance between the cards when the cards are getting smaller
        
            ScrollTrigger.matchMedia({
                "(min-width: 640px)": function() {
                    offsetTop = 64; // equals 4rem or top-16 with tailwind class
                }
            })
        
            const calcAmount = (cards) => {
                const amountEach = spacer / 1000;
                return amountEach * cards;
            };
        
            // calculates the smallest scale located on the top card based on the number of cards available in the section
            const calcMinScale = (cards) => {
                return 1 - calcAmount(cards);
            };
        
            const progressBar = (progress) => {
                const width = progress * 100;
                return width;
            };
        
            document.querySelector(".stacked_point__number").textContent = `01 / 0${cardItems.length}`;
        
            sections.forEach((section, sectionIndex) => {
                const distributor = gsap.utils.distribute({
                    base: calcMinScale(cardItems.length),
                    amount: calcAmount(cardItems.length),
                });
        
                ScrollTrigger.create({
                    trigger: section,
                    start: sectionIndex === 0 ? "top top" : "top center",
                    end: "bottom center",
                    scrub: 1,
                    markers: false,
                    id: `section-${sectionIndex}`,
                    invalidateOnRefresh: true,
                    onUpdate: (trigger) => {
                    // update progress bar
                    let w = progressBar(trigger.progress)
                    gsap.to(".stacked_point__bar", {
                        "--width": `${w}%`,
                        ease: "none",
                    });
                    },
                });
        
                Array.from(cardItems).forEach((card, cardIndex) => {
                    let offsetSectionTop = `bottom-=${
                        cardItems[cardItems.length - 1].clientHeight +
                        spacer * (cardItems.length - 1)
                    } top+=${offsetTop}`;
                    const scaleVal = distributor(cardIndex, cardItems[cardIndex], cardItems);
        
                    // scaling motion for the card
                    const tween = gsap.to(card, {
                        scrollTrigger: {
                            trigger: card,
                            start: "top top",
                            markers: false,
                            invalidateOnRefresh: true,
                            toggleActions: "play none none reverse",
                            onEnterBack: () => {
                            // update number once entering card from below
                            document.querySelector(".stacked_point__number").textContent = `0${
                                cardIndex + 1
                            } / 0${cardItems.length}`;
                            },
                        },
                        ease: "none",
                        scale: scaleVal,
                    });
        
                    // pin the whole cards and lift out the pin after endTrigger condition is fulfilled
                    ScrollTrigger.create({
                        trigger: card,
                        start: `top-=${cardIndex * spacer} top+=${offsetTop}`,
                        endTrigger: section,
                        end: offsetSectionTop,
                        pin: true,
                        pinSpacing: false,
                        markers: false,
                        invalidateOnRefresh: true,
                        id: `card-${cardIndex}`,
                        onEnter: () => {
                        // update number once entering card from above
                        document.querySelector(".stacked_point__number").textContent = `0${
                            cardIndex + 1
                        } / 0${cardItems.length}`;
                        },
                    });
                });
            });
        } catch (error) {        
        }
    }

    window.addEventListener('resize', function() {
        init();
    })

    init();
}